import { useToast } from '@components/common/toast';
import { copyString } from '@utils/common';
import classnames from 'classnames/bind';
import styles from './urlShareButton.module.scss';

const cx = classnames.bind(styles);

interface IUrlShareButtonProps {
  url: string;
}

const UrlShareButton = (props: IUrlShareButtonProps) => {
  const { url } = props;
  const Toast = useToast();

  const handleCopyClick = () => {
    copyString(
      () =>
        Toast({
          iconType: 'info',
          content: 'URL을 복사했습니다.',
        }),
      url,
    );
  };

  return (
    <li>
      <a className={cx('urlBtn')} role="button" onClick={handleCopyClick} />
    </li>
  );
};

export default UrlShareButton;
